import {
  LuArchive, LuCalendarDays, LuChartColumn, LuCirclePlus, LuFileText, LuFilter, LuGauge,
  LuImage, LuInbox, LuLayers, LuLayoutList, LuMegaphone, LuPalette, LuPuzzle, LuRefreshCw,
  LuSave, LuSearch, LuShieldCheck, LuSparkles, LuStar, LuTarget, LuUserRound, LuUsers,
  LuUsersRound,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('marketing', '/marketing', 'marketing', [
    ['tabs', 'marketing.tabs', LuMegaphone],
    ['kpis', 'marketing.kpis', LuChartColumn, opt],
  ]),
  tour('marketing_campaigns', '/marketing/campaigns', 'marketing', [
    ['list', 'marketing_campaigns.list', LuLayoutList, { placement: 'top' }],
    ['search', 'marketing_campaigns.search', LuSearch],
    ['create', 'marketing_campaigns.create', LuCirclePlus, opt],
  ], { exact: true }),
  tour('marketing_calendar', '/marketing/calendar', 'marketing', [
    ['grid', 'marketing_calendar.grid', LuCalendarDays, { placement: 'top' }],
    ['view', 'marketing_calendar.view', LuLayers],
    ['drafts', 'marketing_calendar.drafts', LuInbox, { placement: 'right', ...opt }],
  ]),
  tour('marketing_contacts', '/marketing/contacts', 'marketing', [
    ['views', 'marketing_contacts.views', LuUsers],
    ['list', 'marketing_contacts.list', LuLayoutList, { placement: 'top' }],
    ['add', 'marketing_contacts.add', LuCirclePlus, opt],
  ]),
  // Audience sub-tabs that switch in place (no URL change).
  tour('marketing_audiences', null, 'marketing', [
    ['lists', 'marketing_audiences.lists', LuUsersRound, { placement: 'top' }],
    ['create', 'marketing_audiences.create', LuCirclePlus, opt],
  ], { page: 'marketing_audiences' }),
  tour('marketing_segments', null, 'marketing', [
    ['profiler', 'marketing_segments.profiler', LuSparkles],
    ['grid', 'marketing_segments.grid', LuTarget, { placement: 'top', ...opt }],
  ], { page: 'marketing_segments' }),
  tour('marketing_personas', '/marketing/personas', 'marketing', [
    ['intro', 'marketing_personas.intro', LuUserRound],
    ['create', 'marketing_personas.create', LuCirclePlus, opt],
    ['sync', 'marketing_personas.sync', LuRefreshCw, opt],
  ]),
  tour('marketing_scoring', '/marketing/scoring', 'marketing', [
    ['list', 'marketing_scoring.list', LuStar, { placement: 'top' }],
    ['create', 'marketing_scoring.create', LuCirclePlus, opt],
    ['sync', 'marketing_scoring.sync', LuRefreshCw, opt],
  ]),
  tour('marketing_content', '/marketing/content', 'marketing', [
    ['intro', 'marketing_content.intro', LuPuzzle],
    ['create', 'marketing_content.create', LuCirclePlus, opt],
  ]),
  tour('marketing_templates', '/marketing/templates', 'marketing', [
    ['list', 'marketing_templates.list', LuFileText, { placement: 'top' }],
    ['create', 'marketing_templates.create', LuCirclePlus, opt],
  ]),
  tour('marketing_capping', '/marketing/capping', 'marketing', [
    ['toggle', 'marketing_capping.toggle', LuShieldCheck],
    ['limits', 'marketing_capping.limits', LuGauge, { placement: 'top' }],
    ['save', 'marketing_capping.save', LuSave, { placement: 'top' }],
  ]),
  tour('marketing_creatives', '/marketing/creatives', 'marketing', [
    ['gallery', 'marketing_creatives.gallery', LuImage, { placement: 'top' }],
    ['new', 'marketing_creatives.new', LuSparkles, opt],
    ['campaign', 'marketing_creatives.campaign', LuFilter],
  ], { exact: true }),
  tour('marketing_brand', '/marketing/brand', 'marketing', [
    ['profile', 'marketing_brand.profile', LuPalette, { placement: 'top' }],
    ['save', 'marketing_brand.save', LuSave],
  ]),
  tour('marketing_teams', '/marketing/teams', 'marketing', [
    ['intro', 'marketing_teams.intro', LuUsersRound],
    ['new', 'marketing_teams.new', LuCirclePlus, opt],
    ['archived', 'marketing_teams.archived', LuArchive],
  ]),
];

export default tours;
